import React from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'
import { withNamespaces } from "react-i18next";
import { FileCheck, LockKeyholeOpen, ServerCog } from 'lucide-react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { postSale, putUpdateSale } from '../actions/qrsbaqueira'
import { postRedsysGetParams, fetchCustomer } from '../actions/qrs'

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class TicketBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      discountPct: 0,
      date: new Date().toLocaleString(),
      accessCode: '',
      forwardScreen: false,
      downloadingPDF: false,
      descriptionZone: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      qrToken: null,
      lockerMatricula: null,
      lockerCustomer: null,
      qrType: null,
      qrMode: null,
      lockerInvoice: null,
      language: null,
      startDate: null,
      endDate: null,
      customerName: null,
      mail: null,
      phoneNumber: null,
      pinAssigned: [],
      Ds_MerchantCode: null,
      Ds_MerchantName: 'BAQUEIRA BERET',
      Ds_Url: 'https://vacway.com',
      Ds_AuthorisationCode: null,
      Ds_Date: null,
      Ds_Hour: null,
    }

    this.generatePDF = this.generatePDF.bind(this);
  }

  componentDidMount() {
    // Add the beforeunload event listener
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    let authorizeBooking = true;

    const navigationEntries = window.performance.getEntriesByType('navigation');
    if (navigationEntries.length > 0 && navigationEntries[0].type === 'reload') {
      console.log("Page was reloaded");
      authorizeBooking = false;
    }

    if (authorizeBooking) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const lockerPrice = searchParams.get('lockerPrice');
      const discountPct = searchParams.get('discountPct');
      const zoneSelected = searchParams.get('zoneSelected');
      const descriptionZone = searchParams.get('descriptionZone');
      const selectedLocker = searchParams.get('selectedLocker');
      const lockerAssigned = searchParams.get('lockerAssigned');
      const prerentCode = searchParams.get('prerentCode');

      const qrToken = searchParams.get('qrToken');
      const lockerMatricula = searchParams.get('lockerMatricula');
      const lockerCustomer = searchParams.get('lockerCustomer');
      const qrType = searchParams.get('qrType');
      const language = searchParams.get('language');
      const qrMode = searchParams.get('qrMode');

      const startDate = searchParams.get('startDate');
      const endDate = searchParams.get('endDate');
      const customerName = decodeURIComponent(searchParams.get('customerName') || '');
      const mail = searchParams.get('mail');
      const phoneNumber = searchParams.get('phoneNumber');

      const paymentId = searchParams.get('paymentId');

      const dsSignatureVersion = searchParams.get('Ds_SignatureVersion');
      const dsMerchantParameters = searchParams.get('Ds_MerchantParameters');
      const dsSignature = searchParams.get('Ds_Signature');

      console.log("Customer Name:", customerName);

      this.props.i18n.changeLanguage(language);

      this.setState(
        {
          lockerPrice: lockerPrice || 0,
          discountPct: discountPct ? Number(discountPct) : 0,
          descriptionZone: descriptionZone,
          zoneSelected: zoneSelected,
          selectedLocker: selectedLocker,
          lockerAssigned: lockerAssigned,
          qrToken: qrToken,
          lockerMatricula: lockerMatricula,
          lockerCustomer: lockerCustomer,
          qrType: qrType,
          qrMode: qrMode,
          lockerInvoice: prerentCode,
          language: language,
          startDate: startDate,
          endDate: endDate,
          customerName: customerName,
          mail: mail,
          phoneNumber: phoneNumber,
        },
        () => {
          const saleData = {
            PrerentCode: this.state.lockerInvoice,
            CustomerName: this.state.customerName,
            CustomerEmail: this.state.mail,
            CustomerPhone: this.state.phoneNumber,
            EmailLanguage: this.state.language === 'en' ? 'gb' : 'es',
            SendEmail: true,
            SaleQR: this.state.qrToken,
            auth_code: null,
            payment_id: paymentId,
            order_id: null,
            merchant_id: null,
            payment_date: null,
            payment_time: null,
          };

          const paramsRedsys = {
            Ds_SignatureVersion: dsSignatureVersion,
            Ds_MerchantParameters: dsMerchantParameters,
            Ds_Signature: dsSignature,
            parameterToFetch: 'all',
            secretKey: null,
          };

          // Post the sale data
          this.props.postSale(saleData)
            .then((answer) => {
              const today = new Date().toLocaleString();
              const pinAssigned = answer.response.PinAssigned || [];

              this.setState({
                date: today,
                pinAssigned: pinAssigned,
              });

              this.TotalComponent();

              // Fetch customer data
              return this.props.fetchCustomer('6669b7f41628a3b21f4ceaa0');
            })
            .then((customer) => {
              if (!customer || !customer.response || !customer.response.Redsys) {
                throw new Error("Invalid customer response or missing Redsys data");
              }

              paramsRedsys.secretKey = customer.response.Redsys.SECRETKEY;

              // Fetch Redsys parameters
              return this.props.postRedsysGetParams(paramsRedsys);
            })
            .then((answer) => {
              console.log("RedsysResponse:", answer);

              const saleUpdateDate = {
                auth_code: answer.response.decodedParams?.Ds_AuthorisationCode || 'N/A',
                order_id: answer.response.decodedParams?.Ds_Order || 'N/A',
                merchant_id: answer.response.decodedParams?.Ds_MerchantCode || 'N/A',
                payment_date: answer.response.decodedParams?.Ds_Date || new Date().toLocaleDateString(),
                payment_time: answer.response.decodedParams?.Ds_Hour || new Date().toLocaleTimeString(),
              };

              // Update the sale
              this.props.putUpdateSale(prerentCode, saleUpdateDate);

              this.setState({
                Ds_AuthorisationCode: saleUpdateDate.auth_code,
                Ds_MerchantCode: saleUpdateDate.merchant_id,
                Ds_Date: saleUpdateDate.payment_date,
                Ds_Hour: saleUpdateDate.payment_time,
              });
            })
            .catch((error) => {
              console.error("An error occurred:", error);

              // Ensure fallback or recovery logic
              this.TotalComponent();
            });
        }
      );
    }
  }

  componentWillUnmount() {
    // Remove the beforeunload event listener to prevent memory leaks
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (event) => {
    // Set the returnValue property of the event to show the alert message
    event.preventDefault();
  };

  getImageDataURL = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const image = new Image();

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };

      image.onerror = (error) => {
        reject(error);
      };

      image.src = imageUrl;
    });
  };

  TotalComponent() {
    const { iva, lockerPrice } = this.state;

    let importeBase = (lockerPrice / (1 + (iva / 100))).toFixed(2)
    let importeIva = (lockerPrice - importeBase).toFixed(2)
    let total = Number(lockerPrice).toFixed(2)

    this.setState({ importeBase: importeBase, importeIva: importeIva, total: total });

    return { total, importeBase, importeIva, iva };
  }

  getLockerType(type) {

    const { t, i18n } = this.props

    switch (type) {
      case "BNS":
        return 'STANDARD'
      case "CNS":
        return 'STANDARD CARGA'
      case "BWS":
        return 'STANDARD XL'
      case "CWS":
        return 'STANDARD CARGA XL'
      case "BNM":
        return 'MEDIUM'
      case "CNM":
        return 'MEDIUM CARGA'
      case "BWM":
        return 'MEDIUM XL'
      case "CWM":
        return 'MEDIUM CARGA XL'
      case "BNL":
        return 'LARGE'
      case "CNL":
        return 'LARGE CARGA'
      case "BWL":
        return 'LARGE XL'
      case "CWL":
        return 'LARGE CARGA XL'
      case "BNXL":
        return 'LARGE'
      case "CNXL":
        return 'LARGE CARGA'
      case "BWXL":
        return 'LARGE XL'
      case "CWXL":
        return 'LARGE CARGA XL'
      case "BN2XL":
        return 'LARGE'
      case "CN2XL":
        return 'LARGE CARGA'
      case "BW2XL":
        return 'LARGE XL'
      case "CW2XL":
        return 'LARGE CARGA XL'
      case "BN3XL":
        return t('2 Equipos de esquí')
      case "CN3XL":
        return t('3 Equipos de esquí')
      case "BW3XL":
        return t('4 Equipos de esquí')
      case "CW3XL":
        return t('SKI CARGA XL')
      default:
        return 'STANDARD'
    }
  }

  render() {
    const { t } = this.props
    const { iva, importeBase, importeIva, total, discountPct, downloadingPDF,
      zoneSelected, selectedLocker, lockerAssigned, lockerInvoice, descriptionZone,
      qrToken, startDate, endDate, pinAssigned,
      Ds_AuthorisationCode, Ds_Date, Ds_Hour
    } = this.state;

    if (!lockerAssigned) {
      return (
        <div className="baqueiraBackground">
          <AppBaqueiraHeader />
          <div className="nm-page">
            <div className="bq-spinner">
              <img src="/images/logo_baqueira.png" alt="Logo" />
            </div>
          </div>
        </div>
      )
    }

    const parseDate = (dateString) => {
      const [day, month, year] = dateString.split('/')
      return new Date(`${year}-${month}-${day}`)
    }
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    const today = formatDate(new Date())
    const normalizedStartDate = formatDate(parseDate(startDate))
    const isStartDateToday = startDate && normalizedStartDate === today

    const lockerList = lockerAssigned.split(',').filter(Boolean)

    // total is the final (already-discounted) gross price. Reverse-calc the original
    // price for display only, mirroring PaymentBaqueiraView.
    const totalNum = Number(total) || 0
    const originalPrice = discountPct > 0 ? totalNum / (1 - discountPct / 100) : totalNum
    const discountAmount = originalPrice - totalNum

    const renderCodeList = () => (
      <div className="bq-ticket-code-list">
        {lockerList.map((num, i) => (
          <div key={i} className="bq-ticket-code-row">
            <div className="bq-ticket-code-item">
              <span className="bq-ticket-code-label">{t('Nº TAQUILLA')}</span>
              <span className="bq-ticket-code-value">{num.trim()}</span>
            </div>
            {isStartDateToday && pinAssigned[i] && (
              <>
                <div className="bq-ticket-code-sep" />
                <div className="bq-ticket-code-item">
                  <span className="bq-ticket-code-label">{t('PIN')}</span>
                  <span className="bq-ticket-code-value">{pinAssigned[i]}</span>
                </div>
              </>
            )}
          </div>
        ))}
        {!isStartDateToday && (
          <p style={{ textAlign: 'center', fontSize: '0.82rem', color: '#6b7280', margin: '8px 0 0' }}>
            {t('El PIN se enviará al email el día de inicio de tu reserva')}
          </p>
        )}
        {isStartDateToday && pinAssigned.length === 0 && (
          <p style={{ textAlign: 'center', fontSize: '0.82rem', color: '#6b7280', margin: '8px 0 0' }}>
            {t('El PIN se ha enviado a tu email')}
          </p>
        )}
      </div>
    )

    const renderSummary = () => (
      <div className="bq-form">
        <div className="bq-ticket-card-header">
          <div className="bq-ticket-card-header-text">
            <h3>{t('Resumen de reserva')}</h3>
          </div>
          <FileCheck className="bq-form-icon" strokeWidth={1} />
        </div>
        <div className="bq-pay-fields">
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Código de reserva')}</span>
            <span className="bq-pay-field-value">{lockerInvoice}</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Zona')}</span>
            <span className="bq-pay-field-value">{zoneSelected} — {descriptionZone}</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Inicio')}</span>
            <span className="bq-pay-field-value">{startDate}</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Fin')}</span>
            <span className="bq-pay-field-value">{endDate}</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Taquilla')}</span>
            <span className="bq-pay-field-value">{this.getLockerType(selectedLocker)}</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Cantidad')}</span>
            <span className="bq-pay-field-value">{lockerList.length}</span>
          </div>
          {discountPct > 0 && (
            <>
              <div className="bq-pay-field">
                <span className="bq-pay-field-label">{t('Importe Original')}</span>
                <span className="bq-pay-field-value">{originalPrice.toFixed(2)} €</span>
              </div>
              <div className="bq-pay-field">
                <span className="bq-pay-field-label">{t('Descuento')} ({discountPct}%)</span>
                <span className="bq-pay-field-value bq-pay-discount-value">−{discountAmount.toFixed(2)} €</span>
              </div>
            </>
          )}
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Base')}</span>
            <span className="bq-pay-field-value">{importeBase} €</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('IVA')} ({iva}%)</span>
            <span className="bq-pay-field-value">{importeIva} €</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('Total')}</span>
            <span className="bq-pay-field-value" style={{ fontWeight: 800 }}>{total} €</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('AUTH')}</span>
            <span className="bq-pay-field-value" style={{ fontSize: '0.78rem' }}>{Ds_AuthorisationCode}</span>
          </div>
          <div className="bq-pay-field">
            <span className="bq-pay-field-label">{t('FECHA')}</span>
            <span className="bq-pay-field-value" style={{ fontSize: '0.78rem' }}>{Ds_Hour}/{Ds_Date}</span>
          </div>
        </div>
      </div>
    )

    const renderInstructions = () => (
      <div className="bq-form">
        <div className="bq-ticket-card-header">
          <div className="bq-ticket-card-header-text">
            <h3>{t('Instrucciones')}</h3>
          </div>
          <ServerCog className="bq-form-icon" strokeWidth={1} />
        </div>
        {[
          { step: 1, img: '/images/lockerBasicClosedStep1.svg', text: t('LOCALIZA TU TAQUILLA') },
          { step: 2, img: '/images/lockerBasicClosedStep2.svg', text: t('TOCA EL TECLADO') },
          { step: 3, img: '/images/lockerBasicClosedStep3.svg', text: t('INTRODUCE TU PIN') },
          { step: 4, img: '/images/lockerBasicOpenedStep4.svg', text: t('ABRE LAS VECES QUE QUIERAS') },
        ].map(({ step, img, text }) => (
          <div key={step} className="bq-ticket-step">
            <div className="bq-ticket-step-num">{step}</div>
            <img src={img} alt={`Paso ${step}`} className="bq-ticket-step-img" />
            <div className="bq-ticket-step-body">
              <span className="bq-ticket-step-label">{t(`PASO ${step}`)}</span>
              <span className="bq-ticket-step-text">{text}</span>
            </div>
          </div>
        ))}
      </div>
    )

    return (
      <div className="baqueiraBackground">
        <AppBaqueiraHeader />
        <div className="nm-page">

          {/* Success banner */}
          <div className="bq-ticket-success-banner">
            <div className="bq-ticket-success-text">
              <h3>{t('¡GRACIAS POR RESERVAR TU TAQUILLA!')}</h3>
              <p>{t('Sigue las instrucciones que encontrarás a continuación o en tu email.')}</p>
            </div>
            <img className="bq-ticket-confetti" src="/images/animated-icons/firecracker.gif" alt="finish" />
          </div>

          {/* Locker codes */}
          <div className="bq-form">
            <div className="bq-ticket-card-header">
              <div className="bq-ticket-card-header-text">
                <h3>{t('Información de taquilla')}</h3>
              </div>
              <LockKeyholeOpen className="bq-form-icon" strokeWidth={1} />
            </div>
            {renderCodeList()}
          </div>

          {/* Responsive 2-column on desktop, stacked on mobile */}
          <div className="bq-ticket-grid">
            <div className="bq-ticket-col-left">
              {renderSummary()}
            </div>
            <div className="bq-ticket-col-right">
              {renderInstructions()}
            </div>
          </div>

        </div>

        <div className="bq-ticket-action-bar">
          {downloadingPDF ? (
            <span className="bq-ticket-action-btn bq-ticket-action-btn-download">
              <span className="bq-btn-spinner"></span>
            </span>
          ) : (
            <button className="bq-ticket-action-btn bq-ticket-action-btn-download" onClick={this.generatePDF}>
              ↓ {t('DESCARGAR TICKET')}
            </button>
          )}
          <button
            className="bq-ticket-action-btn bq-ticket-action-btn-new"
            onClick={() => history.push(`/qrsale/${qrToken}`)}
          >
            + {t('NUEVA RESERVA')}
          </button>
        </div>
      </div>
    )
  }


  generatePDF = async () => {
    const {
      iva, importeBase, importeIva, total,
      selectedLocker, lockerAssigned, lockerInvoice,
      startDate, endDate, customerName, mail, phoneNumber,
      Ds_AuthorisationCode, Ds_Date, Ds_Hour,
    } = this.state;

    const { t } = this.props;

    this.setState({ downloadingPDF: true });

    // Branded Baqueira letterhead used as the full-page background
    const invoiceBackDataURL = await this.getImageDataURL('/images/baqueira/invoice_back.png');

    const NAVY = '#0A1D3D';
    const GRAY = '#333333';
    const CONTENT_W = 485; // A4 width (595.28) minus left+right margins (55+55)
    const quantity = lockerAssigned ? lockerAssigned.split(',').filter(Boolean).length : 0;

    // Label (left) + value (right) on a single row
    const detailRow = (label, value, emphasize = false) => ({
      columns: [
        { text: label, width: '*', style: emphasize ? 'rowLabelStrong' : 'rowLabel' },
        { text: value, width: 'auto', alignment: 'right', style: emphasize ? 'rowValueStrong' : 'rowValue' },
      ],
      margin: [0, 3, 0, 3],
    });

    // Section heading with a navy underline
    const sectionTitle = (txt) => ([
      { text: txt, style: 'sectionTitle', margin: [0, 14, 0, 4] },
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: CONTENT_W, y2: 0, lineWidth: 1, lineColor: NAVY }], margin: [0, 0, 0, 8] },
    ]);

    const gdprText = t('Está recibiendo este mail porqué está registrado en la base de datos del grupo BAQUEIRA BERET. En cumplimiento de lo dispuesto en el GDPR y LOPDGDD, le informamos de que los datos personales serán tratados por un interés legítimo y para el envío de comunicaciones sobre nuestros productos y servicios, y se conservarán mientras ninguna de las partes se oponga a ello, no serán cedidos a terceros, excepto al GRUPO EMPRESARIAL DE BAQUEIRA (Baqueira Beret, S.A, Viajes Baqueira Beret, S.A; Hoteles Valle de Aran S.A) o por obligación legal. Puede ejercer los derechos de acceso, rectificación, portabilidad, supresión, limitación y oposición enviando un mensaje a protecciondatos@baqueira.es.');

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [55, 95, 55, 90],
      background: (currentPage, pageSize) => ({
        image: invoiceBackDataURL,
        width: pageSize.width,
        height: pageSize.height,
      }),
      content: [
        { text: t('BAQUEIRA BERET TICKET TAQUILLAS'), style: 'docTitle' },
        { text: `${t('Nº de reserva')}: ${lockerInvoice}`, style: 'docSubtitle' },
        {
          columns: [
            {
              width: '*',
              stack: [
                { text: t('Información de cliente'), style: 'colTitle' },
                { text: `${t('Nombre')}: ${customerName || ''}`, style: 'colText', margin: [0, 3, 0, 0] },
                { text: `${t('Email')}: ${mail || ''}`, style: 'colText' },
                { text: `${t('Teléfono')}: ${phoneNumber || ''}`, style: 'colText' },
              ],
            },
            {
              width: '*',
              stack: [
                { text: t('Información de operador'), style: 'colTitle', alignment: 'right' },
                { text: 'BAQUEIRA BERET, SA', style: 'colText', alignment: 'right', margin: [0, 3, 0, 0] },
                { text: 'Afores, s/n 25598 Salardú (Lleida)', style: 'colText', alignment: 'right' },
                { text: 'CIF A25005620', style: 'colText', alignment: 'right' },
              ],
            },
          ],
          columnGap: 20,
          margin: [0, 20, 0, 0],
        },

        ...sectionTitle(t('Detalles del alquiler')),
        detailRow(t('Código de reserva'), `${lockerInvoice}`),
        detailRow(t('Fecha de inicio'), `${startDate}`),
        detailRow(t('Fecha de fin'), `${endDate}`),
        detailRow(t('Tipo de taquilla'), this.getLockerType(selectedLocker)),
        detailRow(t('Cantidad adquirida'), `${quantity}`),

        ...sectionTitle(t('Detalles del pago')),
        detailRow(t('Importe base'), `${importeBase} €`),
        detailRow(`${t('Importe impuestos')} (${iva}%)`, `${importeIva} €`),
        detailRow(t('Importe total'), `${total} €`, true),

        // Redsys payment authorisation — only present for real card payments
        // ('N/A' is the fallback set for free reservations, so exclude it)
        ...((Ds_AuthorisationCode && Ds_AuthorisationCode !== 'N/A') ? [
          ...sectionTitle(t('Información de pago')),
          detailRow(t('Código de autorización'), `${Ds_AuthorisationCode}`),
          detailRow(t('Fecha de pago'), `${Ds_Date} ${Ds_Hour}`),
        ] : []),

        {
          text: gdprText,
          style: 'gdpr',
          width: CONTENT_W,
          absolutePosition: { x: 55, y: 700 },
        },
      ],
      styles: {
        docTitle: { fontSize: 18, bold: true, color: NAVY, alignment: 'center' },
        docSubtitle: { fontSize: 11, color: GRAY, alignment: 'center', margin: [0, 4, 0, 0] },
        colTitle: { fontSize: 11, bold: true, color: NAVY },
        colText: { fontSize: 10, color: GRAY, margin: [0, 1, 0, 0] },
        sectionTitle: { fontSize: 12, bold: true, color: NAVY },
        rowLabel: { fontSize: 10, color: GRAY },
        rowValue: { fontSize: 10, color: GRAY },
        rowLabelStrong: { fontSize: 12, bold: true, color: NAVY },
        rowValueStrong: { fontSize: 12, bold: true, color: NAVY },
        gdpr: { fontSize: 7, color: '#777777', alignment: 'center' },
      },
      defaultStyle: { fontSize: 10, color: GRAY },
    };

    pdfMake.createPdf(docDefinition).download(`BaqueiraBeret-${lockerInvoice}.pdf`);
    this.setState({ downloadingPDF: false });
  }

}

const mapStateToProps = state => ({
  auth: true,
  salebaqueira: state.salebaqueira,
  booking: state.booking
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postSale: bindActionCreators(postSale, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  putUpdateSale: bindActionCreators(putUpdateSale, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(TicketBaqueiraView));